import {useLocation} from "react-router-dom";

export function useLang() {
    const location = useLocation();
    return location.pathname.includes("/en/") ? "en" : "it";
}